import { useMemo } from 'react';
import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import isEventComplete from './eventCompleteness';

export default function useDraftEvents() {
  const currentUser = useUser();

  const draftEvents = useConnect('event.find', {
    where: {
      filter: { active: false, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });

  const activeEvents = useConnect('event.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });

  const data = useMemo(() => [
    ...(draftEvents.data || []),
    ...(activeEvents.data || []).filter(event => !isEventComplete(event))
  ].sort((a, b) => {
    const aCreatedAt = new Date(a.data?.createdAt).getTime() || 0;
    const bCreatedAt = new Date(b.data?.createdAt).getTime() || 0;

    return bCreatedAt - aCreatedAt;
  }), [draftEvents.data, activeEvents.data]);

  const state = (
    draftEvents.state === PayloadStates.FETCHING ||
    activeEvents.state === PayloadStates.FETCHING
  ) ? PayloadStates.FETCHING : draftEvents.state;

  return { ...draftEvents, state, data };
}
